import { Card } from '@/components/common'

interface Activity {
  id: string
  type: 'subscription' | 'usage' | 'organization' | 'system'
  message: string
  timestamp: string
  icon: string
}

// Mock activity data - will be replaced with API call
const mockActivities: Activity[] = [
  {
    id: '1',
    type: 'subscription',
    message: 'BLIS Professional plan activated',
    timestamp: '2 hours ago',
    icon: 'check_circle',
  },
  {
    id: '2',
    type: 'usage',
    message: 'Reached 80% of monthly analysis limit',
    timestamp: '1 day ago',
    icon: 'warning',
  },
  {
    id: '3',
    type: 'organization',
    message: 'New member added to organization',
    timestamp: '2 days ago',
    icon: 'person_add',
  },
  {
    id: '4',
    type: 'system',
    message: 'Monthly usage reset completed',
    timestamp: '3 days ago',
    icon: 'refresh',
  },
]

export const ActivityFeed: React.FC = () => {
  return (
    <Card>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-text-main-light dark:text-text-main-dark">
          Recent Activity
        </h3>
        <button className="text-sm text-primary hover:underline">View All</button>
      </div>
      <div className="space-y-3">
        {mockActivities.map((activity) => (
          <div
            key={activity.id}
            className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors"
          >
            <span
              className="material-symbols-outlined text-text-sub-light dark:text-text-sub-dark"
              style={{ fontSize: '20px' }}
            >
              {activity.icon}
            </span>
            <div className="flex-1">
              <p className="text-sm text-text-main-light dark:text-text-main-dark">
                {activity.message}
              </p>
              <p className="text-xs text-text-sub-light dark:text-text-sub-dark mt-1">
                {activity.timestamp}
              </p>
            </div>
          </div>
        ))}
      </div>
    </Card>
  )
}

